import { useSsoAccessToken } from "@/composables/user/ssoAccessToken";
import { ApiClient } from "@/services/apiClient/ApiClient";
import { afterLogin } from "@/services/user/auth/login/afterLoginService";
import { Authentication } from "@/services/user/auth/login/authenticationService";
import { setupUserInApp } from "@/services/user/auth/login/helpers";
import type { LoginProvider } from "@/services/user/auth/login/sso/types";
import { ThirdPartyLoginStatus } from "@/services/user/auth/login/sso/types";
import { type User } from "@/services/user/userTypes";
import { trackRegistrationDone } from "@/services/analytics/analyticsHelpers";
import { showErrorToast } from "@/services/toasts";

type ApiResponse_ThirdPartyLoginAuthentication_ok = {
  status: ThirdPartyLoginStatus.Ok;
  user: User;
  isFirstLogin: boolean;
};

type ApiResponse_ThirdPartyLoginAuthentication_error = {
  status: ThirdPartyLoginStatus.AccountInactive | ThirdPartyLoginStatus.DifferentAccountType | ThirdPartyLoginStatus.WrongData;
  message: string;
};

type ApiResponse_ThirdPartyLoginAuthentication = ApiResponse_ThirdPartyLoginAuthentication_ok | ApiResponse_ThirdPartyLoginAuthentication_error;

export async function ssoLogin(token: string, provider: LoginProvider): Promise<void> {
  return thirdPartyLogin(token, false, provider).then((response: ApiResponse_ThirdPartyLoginAuthentication) => {
    if (response.status === ThirdPartyLoginStatus.Ok) {
      Authentication.resolveManually();

      if (response.isFirstLogin) {
        trackRegistrationDone();
      }

      return setupUserInApp(response.user).then(async () => {
        useSsoAccessToken().value = token;
        await afterLogin();
      });
    } else {
      showErrorToast(response.message);
    }
  });
}

/** @deprecated */
export async function thirdPartyLogin(token: string, registerNewsletter: boolean, provider: LoginProvider): Promise<ApiResponse_ThirdPartyLoginAuthentication> {
  const url = "user/third-party-login";
  const data = {
    token,
    provider,
    newsletter: registerNewsletter ? 1 : 0,
  };

  return ApiClient.postPublic<ApiResponse_ThirdPartyLoginAuthentication>(url, {}, data).then((response) => response.data);
}
